import { useState } from "react";
import { useMfgItems, type MfgItemRow } from "@/lib/mfg-catalog";
import { Input } from "@/components/ui/input";

export function MfgRootPicker({ onPick }: { onPick: (item: MfgItemRow) => void }) {
  const [q, setQ] = useState("");
  const { data } = useMfgItems({ q, itemTypeCode: "Assembly", page: 1, pageSize: 20 });
  return (
    <div className="space-y-2">
      <Input placeholder="Search products (assemblies)…" value={q} onChange={(e) => setQ(e.target.value)} />
      <ul className="max-h-56 overflow-auto rounded-md border">
        {(data?.rows ?? []).map((r) => (
          <li key={r.mfgItemId}><button type="button" className="w-full px-3 py-2 text-left text-sm hover:bg-accent" onClick={() => onPick(r)}>{r.name}</button></li>
        ))}
      </ul>
    </div>
  );
}
